import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import queryString from 'query-string';

import {request} from '../../containers/actions';
import CommentForm from './comment_form.js';
import Comment from './comment.js';
import '../../libraries';

var gettext = window.gettext ;


export default class CommentList extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static defaultProps = {
        placeholder: '',
        actions: [],
        rates: [],
        ratesWidth: '40%',
        refresh: () => undefined,
        readonly: false,
    }

    state = {
        comments: [],
        averageRates: {},
    }

    componentDidMount() {
        this.fetch.bind(this)();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.target, this.props.target))
            this.fetch.bind(this)();
    }

    async fetch() {
        const response = await this.context.store.dispatch(request({
            path: '/comment/?' + queryString.stringify({
                target: this.props.target.join(':'),
                o: '-id',
            }),
        }));
        this.setState({
            comments: response.results,
            count: response.count,
            averageRates: response.average_rates,
        });
    }

    async fetchMore() {
        const response = await this.context.store.dispatch(request({
            path: '/comment/?' + queryString.stringify({
                target: this.props.target.join(':'),
                offset: this.state.comments.length,
                o: '-id',
            }),
        }));
        this.setState(update(this.state, {
            comments: {$push: response.results},
            count: {$set: response.count},
            averageRates: {$set: response.average_rates},
        }));
    }

    render() {
        return <div style={{paddingLeft: '.5em'}}>
            {!this.props.readonly
                ? <CommentForm
                    target={this.props.target}
                    refresh={() => {
                        if (this.props.refresh)
                            this.props.refresh();
                        this.fetch.bind(this)();
                    }}
                    placeholder={this.props.placeholder}
                    rates={this.props.rates}
                    ratesWidth={this.props.ratesWidth}
                    averageRates={this.state.averageRates}
                    bodyPreprocessor={this.props.bodyPreprocessor}
                    style={this.props.formStyle}
                    submitMessage={this.props.submitMessage}
                />
                : null
            }
            <div style={{marginTop: '1.5em'}}>
                {_.map(
                    this.state.comments,
                    comment => <Comment key={comment.id}
                        data={comment}
                        refresh={this.fetch.bind(this)}
                        actions={this.props.actions}
                        rates={this.props.rates}
                        ratesWidth={this.props.ratesWidth}
                        header={this.props.commentHeader}
                        style={this.props.commentStyle}
                    />,
                )}
                {this.state.comments.length < this.state.count
                    ? <div
                        style={{cursor: 'pointer', textAlign: 'center'}}
                        onClick={this.fetchMore.bind(this)}>
                        {window.gettext('More')}
                    </div>
                    : null
                }
            </div>
        </div>;
    }
}
